import { render, staticRenderFns } from "./BaseInput2.vue?vue&type=template&id=4c48d4da&scoped=true"
import script from "./BaseInput2.vue?vue&type=script&lang=js"
export * from "./BaseInput2.vue?vue&type=script&lang=js"
import style0 from "./BaseInput2.vue?vue&type=style&index=0&id=4c48d4da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c48d4da",
  null
  
)

export default component.exports